import PosCartActions from '../../actions/PosCartActions';
import PopupActions from '../../actions/PopupActions';

class ClearCart extends React.Component {

    constructor(props) {
        super(props);

        this.clearCart = this.clearCart.bind(this);
    }

    clearCart() {
        PosCartActions.clearUserCart(this.props.guest);
        PopupActions.close();
    }

    render() {
        var { guest } = this.props;

        return (
            <div className='popup popup__transparent'>
                <div
                    className='popup__content'
                    style={{'width' : '250px', 'height' : '100px'}}>

                    <div className='popup-header'>
                        Clear Cart?

                        <div
                            className='popup-close'
                            onClick={PopupActions.close}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <div
                        className='btn-green'
                        onClick={PopupActions.close}
                        style={{'width' : '110px', 'margin' : '10px 0 0 10px'}}>

                        No
                    </div>

                    { !guest.IsPaid &&
                        <div
                            className='btn-green'
                            onClick={this.clearCart}
                            style={{'width' : '110px', 'margin' : '10px 0 0 10px'}}>

                            Yes
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default ClearCart;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/ClearCart.react.jsx